module.exports = __webpack_public_path__ + "static/media/FARM_LIGHT_M.9474db0e.png";